import { VALIDATE_TOKEN_V2, VALIDATE_TOKEN_V2_SUCCESS, VALIDATE_TOKEN_V2_ERROR, VALIDATE_TOKEN_V2_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ValidateTokenV2 = (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_TOKEN_V2:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VALIDATE_TOKEN_V2_SUCCESS:
      state = {
        ...state,
        data: action?.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case VALIDATE_TOKEN_V2_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case VALIDATE_TOKEN_V2_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ValidateTokenV2;
